import { create } from "zustand";
const appConfig = (set) => ({
    appConfig: {},
    setAppConfig: (appConfig) => {
        set(() => ({ appConfig }));
    }
});
const useAppConfigStore = create(appConfig);
export default useAppConfigStore;
